<template>
  <div class="d-flex">
    <div class="header-btn-lg pr-0">
      <div class="widget-content p-0">
        <div class="widget-content-wrapper">
          <div class="widget-content-left">
            <b-dropdown
              toggle-class="p-0 mr-2"
              menu-class="dropdown-menu-lg"
              variant="link"
              no-caret
              right
            >
              <span slot="button-content">
                <div class="rounded-circle">
                  <v-avatar size="42" v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar !== null">
                    <v-img :aspect-ratio="1/1" class="rounded-circle" :src="$store.state.userLogged.user_info.avatar.public_url"></v-img>
                  </v-avatar>
                  <v-avatar color="primary" size="42" v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar === null">
                    <span v-if="$store.state.userLogged.user_info.avatar === null" class="white--text headline">
                      <v-icon color="white">person</v-icon>
                    </span>
                  </v-avatar>
                </div>
              </span>
              <div class="dropdown-menu-header">
                <div class="dropdown-menu-header-inner bg-info">
                  <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                  <div class="menu-header-content text-left">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="rounded-circle">
                            <v-avatar size="42" v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar !== null">
                              <v-img :aspect-ratio="1/1" class="rounded-circle" :src="$store.state.userLogged.user_info.avatar.public_url"></v-img>
                            </v-avatar>
                            <v-avatar color="primary" size="42" v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar === null">
                              <span v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar === null" class="white--text headline">
                                <v-icon color="white">person</v-icon>
                              </span>
                            </v-avatar>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">{{$store.state.userLogged.name}}</div>
                          <div class="widget-subheading opacity-8">{{ $store.state.userLogged.company ? $store.state.userLogged.company[0].name : ''}}</div>
                        </div>
                        <div class="widget-content-right mr-2">
                          <button @click="logoutClick()" class="btn-pill btn-shadow btn-shine btn btn-focus text-nowrap">
                            {{$t('general.logout')}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="scroll-area-xs" style="height: 150px;">
                <VuePerfectScrollbar class="scrollbar-container" v-once>
                  <ul class="nav flex-column">
                    <li class="nav-item-header nav-item">Activity</li>
                    <li class="nav-item">
                      <a href="javascript:void(0);" class="nav-link">
                        Chat
                        <div class="ml-auto badge badge-pill badge-info">8</div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="javascript:void(0);" class="nav-link">Recover Password</a>
                    </li>
                    <li class="nav-item-header nav-item">My Account</li>
                    <li class="nav-item">
                      <a href="javascript:void(0);" class="nav-link">
                        Settings
                        <div class="ml-auto badge badge-success">New</div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="javascript:void(0);" class="nav-link">
                        Messages
                        <div class="ml-auto badge badge-warning">512</div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="javascript:void(0);" class="nav-link">Logs</a>
                    </li>
                  </ul>
                </VuePerfectScrollbar>
              </div> -->
              <!-- <ul class="nav flex-column">
                <li class="nav-item-divider mb-0 nav-item"></li>
              </ul> -->
              <div class="grid-menu grid-menu-2col overflow-hidden">
                <div class="no-gutters row">
                  <div class="col-sm-6" v-if="$store.state.userLogged.roles && $store.state.userLogged.roles[0].id !== 3">
                    <button
                      class="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-primary"
                      @click="companyDialog = true"
                    >
                      <i class="lnr-apartment icon-gradient bg-primary btn-icon-wrapper mb-2"></i>{{$t('profiles.companyProfile')}}
                    </button>
                  </div>
                  <div :class="$store.state.userLogged.roles && $store.state.userLogged.roles[0].id === 3 ? 'col-sm-12' : 'col-sm-6'">
                    <button
                      class=" h-100 btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-info"
                      @click="userDialog = true"
                    >
                      <i class="lnr-user icon-gradient bg-info btn-icon-wrapper mb-2"></i>
                      <b>{{$t('profiles.userProfile')}}</b>
                    </button>
                  </div>
                </div>
              </div>
              <!-- <ul class="nav flex-column">
                <li class="nav-item-divider nav-item"></li>
                <li class="nav-item-btn text-center nav-item">
                  <button class="btn-wide btn btn-primary btn-sm">Open Messages</button>
                </li>
              </ul> -->
            </b-dropdown>
          </div>
          <div class="widget-content-left">
            <div class="widget-heading">{{$store.state.userLogged.name}}</div>
            <div class="widget-subheading">{{$store.state.userLogged.company ? $store.state.userLogged.company[0].name : ''}}</div>
          </div>
          <!-- <div class="widget-content-left ml-3 header-user-info">
            <div class="widget-heading">Alina Mclourd</div>
            <div class="widget-subheading">VP People Manager</div>
          </div>
          <div class="widget-content-right header-user-info ml-3">
            <b-btn
              v-b-tooltip.hover
              title="Tooltip Example"
              class="btn-shadow p-1"
              size="sm"
              variant="info"
            >
              <font-awesome-icon icon="calendar-alt" class="mr-1 ml-1" />
            </b-btn>
          </div> -->
        </div>
      </div>
    </div>
    <v-dialog v-if="$store.state.userLogged.company && $store.state.userLogged.roles[0].id !== 3" v-model="companyDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <div class="dropdown-menu-header">
          <div class="menu-header-image dd-header-bg-4"></div>
          <div class="dropdown-menu-header-inner bg-night-sky">
            <div class="menu-header-content">
              <div class="row mx-0">
                <div class="col ml-3 text-left">
                  <h1><strong>{{$t('profiles.companyProfile')}}</strong></h1>
                </div>
                <div class="col text-right">
                  <v-btn depressed icon class="primary--text" color="white" @click="companyDialog = false"><v-icon>close</v-icon></v-btn>
                </div>
              </div>
              <b-row class="mx-0 my-3">
                <b-col xl="4" md="4" sm="12">
                  <v-card v-if="company.logo !== undefined && company.logo === null" class="rounded-circle mx-auto" height="250px" width="250px">
                    <v-layout fill-height align-center justify-center>
                      <v-btn @click="logoDialog = true" fab color="white">
                        <v-icon large>camera_alt</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card>
                  <v-hover
                    v-if="company.logo !== undefined && company.logo !== null"
                  >
                    <v-avatar
                      slot-scope="{ hover }"
                      size="250"
                    >
                      <v-img :aspect-ratio="1/1" :src="company.logo.public_url">
                        <div
                          v-if="hover"
                          class="d-flex v-card--reveal display-3  white--text"
                          style="height: 100%;"
                        >
                          <v-layout fill-height align-center justify-center>
                            <v-btn @click="logoDialog = true" fab dark color="dark">
                              <v-icon large>camera_alt</v-icon>
                            </v-btn>
                          </v-layout>
                        </div>
                      </v-img>
                    </v-avatar>
                  </v-hover>
                </b-col>
                <b-col xl="8" md="8" sm="12">
                  <b-row class="py-1 h-40" align-v="center">
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('profiles.companyName')}}:</strong></h1>
                      <h2>{{company.name}}</h2>
                    </b-col>
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('taxFields.phone')}}:</strong></h1>
                      <h2>{{company.phone}}</h2>
                    </b-col>
                  </b-row>
                  <b-row class="py-1 h-35" align-v="center">
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('taxFields.regime')}}:</strong></h1>
                      <h2>{{company.regimen_fiscal}}</h2>
                    </b-col>
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('taxFields.socialReason')}}:</strong></h1>
                      <h2>{{company.razon_social}}</h2>
                    </b-col>
                  </b-row>
                  <b-row class="py-1 h-35" align-v="center">
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('taxFields.taxId')}}:</strong></h1>
                      <h2>{{company.tax_id}}</h2>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <v-card-text v-if="company.subscriptions.length >= 1">
          <div class="row my-3">
            <div class="col text-center">
              <h1 class="primary--text"><strong>{{$t('profiles.planInfo')}}:</strong></h1>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col-12 col-md-6">
              <div class="card border border-primary widget-chart">
                <div class="widget-chart-content">
                  <div class="icon-wrapper rounded">
                    <div class="icon-wrapper-bg bg-primary"></div>
                    <i class="lnr-license text-primary"></i>
                  </div>
                  <div class="widget-numbers">
                    <span>"{{company.subscriptions[0].plan[0].name}}"</span>
                  </div>
                  <v-chip class="bg-danger mb-4 white--text font-weight-bold">
                    {{$t('profiles.deadline') + ': ' + company.subscriptions[0].expiration_date}}
                  </v-chip>
                  <div class="grid-menu grid-menu-2col overflow-hidden">
                    <div class="no-gutters row">
                      <div class="col-sm-6">
                        <button
                          class="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-primary"
                          @click="companyDialog = true"
                        >
                          <i class="lnr-user icon-gradient bg-primary btn-icon-wrapper mb-2"></i>
                          {{$t('profiles.minUsers')}}:
                          <p class="mb-0">{{company.subscriptions[0].plan[0].min_users}}</p>
                        </button>
                      </div>
                      <div class="col-sm-6">
                        <button
                          class="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-danger"
                        >
                          <i class="lnr-user icon-gradient bg-danger btn-icon-wrapper mb-2"></i>
                          {{$t('profiles.maxUsers')}}:
                          <p class="mb-0">{{company.subscriptions[0].plan[0].max_users}}</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="$store.state.userLogged.user_info !== undefined" v-model="userDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <div class="dropdown-menu-header">
          <div class="menu-header-image dd-header-bg-3"></div>
          <div class="dropdown-menu-header-inner bg-dark">
            <div class="menu-header-content">
              <div class="row mx-0">
                <div class="col ml-3 text-left">
                  <h1><strong>{{$t('profiles.userProfile')}}</strong></h1>
                </div>
                <div class="col text-right">
                  <v-btn depressed icon class="primary--text" color="white" @click="userDialog = false"><v-icon>close</v-icon></v-btn>
                </div>
              </div>
              <b-row class="mx-0 my-3">
                <b-col xl="4" md="4" sm="12">
                  <v-card v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar === null" class="rounded-circle mx-auto" height="250px" width="250px">
                    <v-layout fill-height align-center justify-center>
                      <v-btn @click="avatarDialog = true" fab color="white">
                        <v-icon large>camera_alt</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card>
                  <v-hover
                    v-if="$store.state.userLogged.user_info !== undefined && $store.state.userLogged.user_info.avatar !== null"
                  >
                    <v-avatar
                      slot-scope="{ hover }"
                      size="250"
                    >
                      <v-img :aspect-ratio="1/1" :src="$store.state.userLogged.user_info.avatar.public_url">
                        <div
                          v-if="hover"
                          class="d-flex v-card--reveal display-3  white--text"
                          style="height: 100%;"
                        >
                          <v-layout fill-height align-center justify-center>
                            <v-btn @click="avatarDialog = true" fab dark color="dark">
                              <v-icon large>camera_alt</v-icon>
                            </v-btn>
                          </v-layout>
                        </div>
                      </v-img>
                    </v-avatar>
                  </v-hover>
                </b-col>
                <b-col xl="8" md="8" sm="12">
                  <b-row class="py-2 h-40" align-v="center">
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('general.name')}}:</strong></h1>
                      <h2>{{$store.state.userLogged.name}}</h2>
                    </b-col>
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('general.company')}}:</strong></h1>
                      <h2>{{$store.state.userLogged.company[0].name}}</h2>
                    </b-col>
                  </b-row>
                  <b-row class="py-2 h-40" align-v="center">
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('branch.name')}}:</strong></h1>
                      <h2 v-if="$store.state.userLogged.user_info">{{$store.state.userLogged.user_info.branch.branch_name}}</h2>
                    </b-col>
                    <b-col class="px-3">
                      <h1 class="white--text"><strong>{{$t('area.name')}}:</strong></h1>
                      <h2 v-if="$store.state.userLogged.area[0]">{{$store.state.userLogged.area[0].name}}</h2>
                    </b-col>
                  </b-row>
                  <b-row class="py-4 h-20 text-right" align-v="center">
                    <b-col>
                      <v-btn round outline color="white" @click="passwordDialog = true">{{$t('profiles.changePassword')}}</v-btn>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <v-card-text>
          <div class="row justify-content-md-center">
            <div v-if="$store.state.userLogged.user_info !== undefined" class="col-xl-6 col-md-6 col-sm-12">
              <div class="row my-3">
                <div class="col text-center">
                  <h1 class="primary--text"><strong>{{$t('profiles.userInfo')}}:</strong></h1>
                </div>
              </div>
              <div class="card border border-primary widget-chart">
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('general.email')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{$store.state.userLogged.email}}</h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('address.name')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{$store.state.userLogged.user_info.address}}</h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('user.birthDate')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{$store.state.userLogged.user_info.birthdate}}</h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('general.country')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">
                      {{$store.state.userLogged.user_info.country.c_Pais }} - {{$store.state.userLogged.user_info.country.descripcion }}
                    </h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('user.gender')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{setGenre}}</h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('profiles.lang')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{$store.state.userLogged.user_info.lang_preferences}}</h2>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="text-right">
                    <h2 class="primary--text"><strong>{{$t('taxFields.phone')}}:</strong></h2>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <h2 class="primary--text">{{$store.state.userLogged.user_info.phone}}</h2>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog
        v-model="logoDialog"
        persistent
        width="500px"
      >
        <v-card>
          <v-toolbar color="primary">
            <h1 class="white--text">{{$t('profiles.changeLogo')}}</h1>
          </v-toolbar>
          <v-card-text>
            <vue-dropzone
              ref="dropzoneLogo"
              id="dropzoneLogo"
              :options="dropzoneOptions2"
              v-on:vdropzone-file-added="fileAdded"
              v-on:vdropzone-error="fileUploadError"
              v-on:vdropzone-success="fileUpload">
            </vue-dropzone>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" round @click="close">{{$t('general.close')}}</v-btn>
            <v-btn depressed color="primary" round @click="changeLogo">{{$t('general.submit')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="avatarDialog"
        persistent
        width="500px"
      >
        <v-card>
          <v-toolbar color="primary">
            <h1 class="white--text">{{$t('profiles.changeAvatar')}}</h1>
          </v-toolbar>
          <v-card-text>
            <vue-dropzone
              ref="dropzone"
              id="dropzone"
              :options="dropzoneOptions"
              v-on:vdropzone-file-added="fileAdded"
              v-on:vdropzone-error="fileUploadError"
              v-on:vdropzone-success="fileUpload">
            </vue-dropzone>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" round @click="close">{{$t('general.close')}}</v-btn>
            <v-btn depressed color="primary" round @click="changeAvatar">{{$t('general.submit')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="passwordDialog"
        persistent
        width="500px"
      >
        <v-card>
          <v-toolbar color="primary">
            <h1 class="white--text">{{$t('profiles.changePassword')}}</h1>
          </v-toolbar>
          <v-card-text>
            <v-form
              lazy-validation
              ref="passForm"
              v-model="valid"
            >
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="oldPassword"
                      :rules="rules.password"
                      :label="$t('login.oldPass')"
                      :append-icon="showPass ? 'visibility_off' : 'visibility'"
                      :type="showPass ? 'text' : 'password'"
                      :error-messages="errors.oldPassword"
                      @click:append="showPass = !showPass">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="newPassword"
                      :rules="rules.password"
                      :label="$t('login.newPass')"
                      :append-icon="showPass2 ? 'visibility_off' : 'visibility'"
                      :type="showPass2 ? 'text' : 'password'"
                      :error-messages="errors.newPassword"
                      @click:append="showPass2 = !showPass2">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="confirmPassword"
                      :rules="rules.password"
                      :label="$t('login.confirmPass')"
                      :append-icon="showPass3 ? 'visibility_off' : 'visibility'"
                      :type="showPass3 ? 'text' : 'password'"
                      :error-messages="errors.newPassword"
                      @click:append="showPass3 = !showPass3">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              color="primary"
              round
              @click="closePassword">
              {{$t('general.close')}}
            </v-btn>
            <v-btn
            :loading="loading"
            :disabled="loading"
            depressed
            color="primary"
            round
            @click="validate($event)">
            {{$t('general.submit')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <!-- <div class="header-btn-lg">
      <button
        type="button"
        class="hamburger hamburger--elastic"
        v-bind:class="{ 'is-active': showDrawerSection }"
        v-on:click="showDrawerSection = !showDrawerSection"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>

    <div class="app-drawer-wrapper" v-bind:class="{ 'drawer-open': showDrawerSection }">
      <div class="drawer-nav-btn">
        <button
          type="button"
          class="hamburger hamburger--elastic"
          v-bind:class="{ 'is-active': showDrawerSection }"
          v-on:click="showDrawerSection = !showDrawerSection"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
      <div class="drawer-content-wrapper">
        <VuePerfectScrollbar class="scrollbar-container" v-once>
          <h3 class="drawer-heading">Servers Status</h3>
          <div class="drawer-section">
            <div class="row">
              <div class="col">
                <div class="progress-box">
                  <h4>Server Load 1</h4>
                  <vue-circle
                    :progress="21"
                    :size="104"
                    :reverse="false"
                    line-cap="round"
                    :fill="fill1"
                    empty-fill="rgba(0, 0, 0, .08)"
                    :animation-start-value="0.0"
                    :start-angle="90"
                    insert-mode="append"
                    :thickness="7"
                    :show-percent="true"
                  ></vue-circle>
                </div>
              </div>
              <div class="col">
                <div class="progress-box">
                  <h4>Server Load 2</h4>
                  <vue-circle
                    :progress="34"
                    :size="104"
                    :reverse="false"
                    line-cap="round"
                    :fill="fill2"
                    empty-fill="rgba(0, 0, 0, .08)"
                    :animation-start-value="0.0"
                    :start-angle="90"
                    insert-mode="append"
                    :thickness="7"
                    :show-percent="true"
                  ></vue-circle>
                </div>
              </div>
              <div class="col">
                <div class="progress-box">
                  <h4>Server Load 3</h4>
                  <vue-circle
                    :progress="16"
                    :size="104"
                    :reverse="false"
                    line-cap="round"
                    :fill="fill3"
                    empty-fill="rgba(0, 0, 0, .08)"
                    :animation-start-value="0.0"
                    :start-angle="90"
                    insert-mode="append"
                    :thickness="7"
                    :show-percent="true"
                  ></vue-circle>
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="mt-3">
              <h5 class="text-center card-title">Live Statistics</h5>
              <div class="text-center">
                <trend
                  :data="[0, 8, 5, 7, 7, 8, 5, 2, 7, 8]"
                  :gradient="['var(--success)']"
                  stroke-width="3"
                  :height="80"
                  stroke-linecap="round"
                  auto-draw
                  smooth
                ></trend>
              </div>
              <div class="row">
                <div class="col">
                  <div class="widget-chart p-0">
                    <div class="widget-chart-content">
                      <div class="widget-numbers text-warning fsize-3">43</div>
                      <div class="widget-subheading pt-1">Packages</div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="widget-chart p-0">
                    <div class="widget-chart-content">
                      <div class="widget-numbers text-danger fsize-3">65</div>
                      <div class="widget-subheading pt-1">Dropped</div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="widget-chart p-0">
                    <div class="widget-chart-content">
                      <div class="widget-numbers text-success fsize-3">18</div>
                      <div class="widget-subheading pt-1">Invalid</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="divider"></div>
              <div class="text-center mt-2 d-block">
                <button class="mr-2 border-0 btn-transition btn btn-outline-danger">Escalate Issue</button>
                <button class="border-0 btn-transition btn btn-outline-success">Support Center</button>
              </div>
            </div>
          </div>
          <h3 class="drawer-heading">File Transfers</h3>
          <div class="drawer-section p-0">
            <div class="files-box">
              <ul class="list-group list-group-flush">
                <li class="pt-2 pb-2 pr-2 list-group-item">
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div
                        class="widget-content-left opacity-6 fsize-2 mr-3 text-primary center-elem"
                      >
                        <font-awesome-icon icon="file-alt" />
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading font-weight-normal">TPSReport.docx</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="btn-icon btn-icon-only btn btn-link btn-sm">
                          <font-awesome-icon icon="cloud-download-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="pt-2 pb-2 pr-2 list-group-item">
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div
                        class="widget-content-left opacity-6 fsize-2 mr-3 text-warning center-elem"
                      >
                        <font-awesome-icon icon="file-archive" />
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading font-weight-normal">Latest_photos.zip</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="btn-icon btn-icon-only btn btn-link btn-sm">
                          <font-awesome-icon icon="cloud-download-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="pt-2 pb-2 pr-2 list-group-item">
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div
                        class="widget-content-left opacity-6 fsize-2 mr-3 text-danger center-elem"
                      >
                        <font-awesome-icon icon="file-pdf" />
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading font-weight-normal">Annual Revenue.pdf</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="btn-icon btn-icon-only btn btn-link btn-sm">
                          <font-awesome-icon icon="cloud-download-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="pt-2 pb-2 pr-2 list-group-item">
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div
                        class="widget-content-left opacity-6 fsize-2 mr-3 text-success center-elem"
                      >
                        <font-awesome-icon icon="file-excel" />
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading font-weight-normal">Analytics_GrowthReport.xls</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="btn-icon btn-icon-only btn btn-link btn-sm">
                          <font-awesome-icon icon="cloud-download-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <h3 class="drawer-heading">Tasks in Progress</h3>
          <div class="drawer-section p-0">
            <div class="todo-box">
              <ul class="todo-list-wrapper list-group list-group-flush">
                <li class="list-group-item">
                  <div class="todo-indicator bg-warning"></div>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-2">
                        <div class="custom-checkbox custom-control">
                          <input
                            type="checkbox"
                            id="exampleCustomCheckbox1266"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="exampleCustomCheckbox1266">&nbsp;</label>
                        </div>
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading">
                          Wash the car
                          <div class="badge badge-danger ml-2">Rejected</div>
                        </div>
                        <div class="widget-subheading">
                          <i>Written by Bob</i>
                        </div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="border-0 btn-transition btn btn-outline-success">
                          <font-awesome-icon icon="check" />
                        </button>
                        <button class="border-0 btn-transition btn btn-outline-danger">
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="todo-indicator bg-focus"></div>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-2">
                        <div class="custom-checkbox custom-control">
                          <input
                            type="checkbox"
                            id="exampleCustomCheckbox1666"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="exampleCustomCheckbox1666">&nbsp;</label>
                        </div>
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading">Task with hover dropdown menu</div>
                        <div class="widget-subheading">
                          <div>
                            By Johnny
                            <div class="badge badge-pill badge-info ml-2">NEW</div>
                          </div>
                        </div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <div class="d-inline-block">
                          <b-dropdown
                            toggle-class="btn-icon btn-icon-only border-0 btn-transition"
                            variant="link"
                            no-caret
                          >
                            <span slot="button-content">
                              <font-awesome-icon icon="ellipsis-h" />
                            </span>
                            <div>
                              <button
                                type="button"
                                disabled
                                tabindex="-1"
                                class="disabled dropdown-item"
                              >Action</button>
                              <button
                                type="button"
                                tabindex="0"
                                class="dropdown-item"
                              >Another Action</button>
                              <div tabindex="-1" class="dropdown-divider"></div>
                              <button
                                type="button"
                                tabindex="0"
                                class="dropdown-item"
                              >Another Action</button>
                            </div>
                          </b-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="todo-indicator bg-primary"></div>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-2">
                        <div class="custom-checkbox custom-control">
                          <input
                            type="checkbox"
                            id="exampleCustomCheckbox4777"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="exampleCustomCheckbox4777">&nbsp;</label>
                        </div>
                      </div>
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">Badge on the right task</div>
                        <div class="widget-subheading">This task has show on hover actions!</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="border-0 btn-transition btn btn-outline-success">
                          <font-awesome-icon icon="check" />
                        </button>
                      </div>
                      <div class="widget-content-right ml-3">
                        <div class="badge badge-pill badge-success">Latest Task</div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="todo-indicator bg-info"></div>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-2">
                        <div class="custom-checkbox custom-control">
                          <input
                            type="checkbox"
                            id="exampleCustomCheckbox2444"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="exampleCustomCheckbox2444">&nbsp;</label>
                        </div>
                      </div>
                      <div class="widget-content-left mr-3">
                        <div class="widget-content-left">
                          <img width="42" class="rounded" src="@/assets/images/avatars/1.jpg" alt />
                        </div>
                      </div>
                      <div class="widget-content-left">
                        <div class="widget-heading">Go grocery shopping</div>
                        <div class="widget-subheading">A short description ...</div>
                      </div>
                      <div class="widget-content-right widget-content-actions">
                        <button class="border-0 btn-transition btn btn-sm btn-outline-success">
                          <font-awesome-icon icon="check" />
                        </button>
                        <button class="border-0 btn-transition btn btn-sm btn-outline-danger">
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="todo-indicator bg-success"></div>
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-2">
                        <div class="custom-checkbox custom-control">
                          <input
                            type="checkbox"
                            id="exampleCustomCheckbox3222"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="exampleCustomCheckbox3222">&nbsp;</label>
                        </div>
                      </div>
                      <div class="widget-content-left flex2">
                        <div class="widget-heading">Development Task</div>
                        <div class="widget-subheading">Finish React ToDo List App</div>
                      </div>
                      <div class="widget-content-right">
                        <div class="badge badge-warning mr-2">69</div>
                      </div>
                      <div class="widget-content-right">
                        <button class="border-0 btn-transition btn btn-outline-success">
                          <font-awesome-icon icon="check" />
                        </button>
                        <button class="border-0 btn-transition btn btn-outline-danger">
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <h3 class="drawer-heading">Urgent Notifications</h3>
          <div class="drawer-section">
            <div class="notifications-box">
              <div
                class="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--one-column"
              >
                <div class="vertical-timeline-item dot-danger vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in"></span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <h4 class="timeline-title">All Hands Meeting</h4>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
                <div class="vertical-timeline-item dot-warning vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in"></span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <p>
                        Yet another one, at
                        <span class="text-success">15:00 PM</span>
                      </p>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
                <div class="vertical-timeline-item dot-success vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in"></span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <h4 class="timeline-title">
                        Build the production release
                        <div class="badge badge-danger ml-2">NEW</div>
                      </h4>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
                <div class="vertical-timeline-item dot-primary vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in"></span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <h4 class="timeline-title">
                        Something not important
                        <div class="avatar-wrapper mt-2 avatar-wrapper-overlap">
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/1.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/2.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/3.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/4.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/5.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/6.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/7.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm">
                            <div class="avatar-icon">
                              <img src="@/assets/images/avatars/8.jpg" alt />
                            </div>
                          </div>
                          <div class="avatar-icon-wrapper avatar-icon-sm avatar-icon-add">
                            <div class="avatar-icon">
                              <i>+</i>
                            </div>
                          </div>
                        </div>
                      </h4>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
                <div class="vertical-timeline-item dot-info vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in"></span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <h4 class="timeline-title">This dot has an info state</h4>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
                <div class="vertical-timeline-item dot-dark vertical-timeline-element">
                  <div>
                    <span class="vertical-timeline-element-icon is-hidden"></span>
                    <div class="vertical-timeline-element-content is-hidden">
                      <h4 class="timeline-title">This dot has a dark state</h4>
                      <span class="vertical-timeline-element-date"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div> -->
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueCircle from 'vue2-circle-progress'
import Trend from 'vuetrend'
// import { store } from '../../../store'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faCalendarAlt,
  faTrashAlt,
  faCheck,
  faFileAlt,
  faCloudDownloadAlt,
  faFileExcel,
  faFilePdf,
  faFileArchive,
  faEllipsisH
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleDown,
  faCalendarAlt,
  faTrashAlt,
  faCheck,
  faFileAlt,
  faCloudDownloadAlt,
  faFileExcel,
  faFilePdf,
  faFileArchive,
  faEllipsisH
)

export default {
  components: {
    vueDropzone: vue2Dropzone,
    VuePerfectScrollbar,
    'font-awesome-icon': FontAwesomeIcon,
    VueCircle,
    trend: Trend
  },
  data () {
    return {
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'dirname': 'USER_AVATAR',
          'is_public': 1,
          'user_id': this.$store.state.userLogged.id
        }
      },
      dropzoneOptions2: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'dirname': 'COMPANY_LOGO',
          'is_public': 1,
          'user_id': this.$store.state.userLogged.id
        }
      },
      fill1: { gradient: ['#00b09b', '#96c93d'] },
      fill2: { gradient: ['#ff0844', '#ffb199'] },
      fill3: { gradient: ['#f6d365', '#fda085'] },
      showDrawerSection: false,
      companyDialog: false,
      userDialog: false,
      logoDialog: false,
      avatarDialog: false,
      passwordDialog: false,
      valid: true,
      loading: false,
      showPass: false,
      showPass2: false,
      showPass3: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      errors: {},
      editedItem: {
        user_info: {
          avatar: null
        }
      },
      avatarId: null,
      // userLogged: {},
      company: {
        subscriptions: [
          {
            expiration_date: '',
            plan: [
              {
                name: '',
                min_users: null,
                max_users: null
              }
            ]
          }
        ]
      }
    }
  },
  // data: () => ({
  //   fill1: { gradient: ['#00b09b', '#96c93d'] },
  //   fill2: { gradient: ['#ff0844', '#ffb199'] },
  //   fill3: { gradient: ['#f6d365', '#fda085'] },
  //   showDrawerSection: false,
  //   companyDialog: false,
  //   userDialog: false,
  //   avatarDialog: false,
  //   // userLogged: {},
  //   company: {
  //     subscriptions: [
  //       {
  //         expiration_date: '',
  //         plan: [
  //           {
  //             name: '',
  //             min_users: null,
  //             max_users: null
  //           }
  //         ]
  //       }
  //     ]
  //   }
  // }),
  computed: {
    rules () {
      return this.$validationRules()
    },
    setGenre () {
      if (this.$store.state.userLogged.user_info.gender === 'male') {
        return this.$t('profiles.male')
      } else {
        return this.$t('profiles.female')
      }
    }
  },
  watch: {
    '$store.state.userLogged' () {
      this.getCompany()
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      this.dropzoneOptions2.params.user_id = this.$store.state.userLogged.id
      // if (this.userLogged !== undefined) {
      // }
    },
    newPassword () {
      this.errors = {}
    },
    confirmPassword () {
      this.errors = {}
    }
  },
  methods: {
    // getLogged () {
    //   this.userLogged = store.state.userLogged
    // },
    getCompany () {
      this.$store.dispatch('getCompany', {event: {id: this.$store.state.userLogged.company[0] && this.$store.state.userLogged.company[0].id, context: this}})
    },
    fileAdded (file) {
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
        this.dropzoneOptions2.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
        this.dropzoneOptions2.params.files_type_id = 6
      }
    },
    fileUploadError (file, message, xhr) {
      // if (message.errors !== null && message.errors !== undefined) {
      //   // let notificationMessage = message.message + '<br>'
      //   let notificationMessage = ''
      //   if (message.errors.path) {
      //     message.errors.path.forEach(element => {
      //       notificationMessage += element + '<br>'
      //     })
      //   }
      //   if (message.errors.files_type_id) {
      //     message.errors.files_type_id.forEach(element => {
      //       notificationMessage += element + '<br>'
      //     })
      //   }
      //   this.showNotification(notificationMessage, 'error')
      // }
      this.showNotification(message, 'error', -1)
    },
    fileUpload (file, response) {
      this.editedItem.user_info.avatar = response.data.id
      this.avatarId = response.data.id
    },
    close () {
      this.logoDialog = false
      this.avatarDialog = false
      this.avatarId = null
      this.loading = false
      this.errors = {}
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      if (this.$refs.dropzoneLogo !== undefined) {
        this.$refs.dropzoneLogo.removeAllFiles()
      }
    },
    closePassword () {
      this.passwordDialog = false
      this.loading = false
      this.errors = {}
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.$refs.passForm.resetValidation()
    },
    validate () {
      this.errors = {}
      if (this.$refs.passForm.validate()) {
        if (this.newPassword === this.confirmPassword) {
          this.changePassword()
        } else {
          this.showNotification(this.$t('validation.passwordsDoNotMatch'), 'error', -1)
          this.errors.newPassword = this.$t('validation.passwordsDoNotMatch')
        }
      }
    },
    changePassword () {
      this.loading = true
      this.$store.dispatch('changePassword', {event: {newPass: this.newPassword, oldPass: this.oldPassword, context: this}})
    },
    changeAvatar () {
      this.loading = true
      this.$store.dispatch('changeAvatar', {event: {context: this}})
    },
    changeLogo () {
      this.loading = true
      this.$store.dispatch('changeLogo', {event: {context: this}})
    },
    refreshLogged () {
      this.$store.dispatch('userLogged', {event: {context: this}})
    },
    logoutClick (event, item) {
      this.$store.dispatch('logout', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Layout/Components/Header/HeaderUserArea.vue